import type { UseFetchOptions } from '@vueuse/core';
import toastr from 'toastr';

export const toastOnResponse = (response: Record<string, string>) => {
    Object.keys(response).forEach(key => {
        switch (key) {
            case 'toastrSuccessMessage':
                toastr.success(response.toastrSuccessMessage, response.toastrSuccessTitle, { timeOut: 6000 });
                break;
            case 'toastrErrorMessage':
                toastr.error(response.toastrErrorMessage, response.toastrErrorTitle, { timeOut: 15000 });
                break;
            case 'toastrWarningMessage':
                toastr.warning(response.toastrWarningMessage, response.toastrWarningTitle, { timeOut: 10000 });
                break;
            case 'toastrInfoMessage':
                toastr.info(response.toastrInfoMessage, response.toastrInfoTitle, { timeOut: 7000 });
                break;
        }
    });
};

export const toastOnUseFetchResponse = (ctx => {
    toastOnResponse(ctx.data);
    return ctx;
}) satisfies UseFetchOptions['afterFetch'];
